import styled from 'styled-components';

export const Content = styled.div`
  display: none;
  position: absolute;
  padding: ${({ theme }): string => theme.spacers!.spacer04};
  white-space: nowrap;
  border-radius: 8px;
  color: ${({ theme }): string => theme.admanColors!.gray.light.bg0[0]};
  box-shadow: 0 4px 20px -8px ${({ theme }): string => theme.admanColors!.gray.dark.bg0[0]};
  background-color: ${({ theme }): string => theme.admanColors!.gray.dark.bg0[0]};
  font-size: ${({ theme }): string => theme.spacers!.spacer03};

  &::after {
    content: '';
    border-top: 10px solid transparent;
    border-bottom: 10px solid transparent;
    border-right: 10px solid ${({ theme }): string => theme.admanColors!.gray.dark.bg0[0]};
    position: absolute;
    top: 50px;
    left: 45%;
    transform: translate(0, -50%) rotate(-90deg);
  }
`;

export const TooltipWrapper = styled.div<{ $whiteTheme?: boolean }>`
  position: relative;
  z-index: 11;

  .descriptionTooltip {
    margin-bottom: 0;
    padding: 0;
    border-radius: 8px;
    box-shadow: ${({ theme, $whiteTheme }): string =>
      $whiteTheme ? `0px 4px 20px -8px rgb(19 32 57 / 40%) ` : `0 4px 3px -8px ${theme.admanColors!.gray.dark.bg0[0]}`};
    background-color: ${({ theme, $whiteTheme }): string =>
      $whiteTheme ? theme.colors!.colorWhite : theme.admanColors!.gray.dark.bg0[0]};
    font-size: ${({ theme }): string => theme.spacers!.spacer03};
    transition: none;
  }
`;

export const IconWrapper = styled.span`
  display: flex;
  cursor: pointer;

  &:hover {
    fill: ${({ theme }): string => theme.admanColors!.gray.light.fg[1]};
    background-color: ${({ theme }): string => theme.admanColors!.gray.light.bg0[2]};
    border-radius: 25%;
    & + ${Content} {
      display: block;
      left: 50%;
      top: -55px;
      transform: translateX(-50%);
    }
  }
`;

export const TooltipIconWrapper = styled.span<{ disabled: boolean }>`
  display: flex;
  cursor: ${({ disabled }): string => (disabled ? 'not-allowed' : 'pointer')};
  opacity: ${({ disabled }): number => (disabled ? 0.3 : 1)};

  &:hover {
    fill: ${({ theme }): string => theme.admanColors!.gray.light.fg[1]};
    background-color: ${({ theme }): string => theme.admanColors!.gray.light.bg0[2]};
    border-radius: 25%;
  }
`;

export const TooltipContent = styled.div<{ $whiteTheme?: boolean }>`
  color: ${({ theme, $whiteTheme }): string =>
    $whiteTheme ? theme.admanColors!.gray.light.fg[1] : theme.admanColors!.gray.light.bg0[0]};
  padding: ${({ theme }): string => theme.spacers!.spacer04};
  font-size: ${({ theme }): string => theme.spacers!.spacer03};
`;
